// removed by extract-text-webpack-plugin
module.exports = {"small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","container":"container-Ij9GO container-3Sdxl","col":"col-1lqrU","title":"title-aqwVz title-1DYMu","total":"total-1RK7p","renewsOn":"renewsOn-rXJEb","trialPeriod":"trialPeriod-20flg","image":"image-1RQZY","lineItems":"lineItems-LBcAr","text":"text-3EGRL","note":"note-1oxl2 note-1iaUM","doneButton":"doneButton-1Ksz_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_receiptPage.css
// module id = 1248
// module chunks = 1